import { Navigate } from 'react-router-dom';
import { selectUserId } from '../containers/Login/LoginSlice';
import { useAppSelector } from '../hooks';

export const NotFoundPage = () => {
  const userId = useAppSelector(selectUserId);

  if (userId) {
    return <Navigate to="/dashboard" />;
  } else {
    return <Navigate to="/intro" />;
  }
};
